// // remap jQuery to $.
(function($) {
    // trigger when page is ready.
    $(document).ready(function() {
        // Home Page: Latest Updates Slider - depends on Slick.js - http://kenwheeler.github.io/slick/
        homeLatestUpdatesSlick();
        function homeLatestUpdatesSlick() {
            const home_latest_updates_slider = $(".latest-updates-slider");
            home_latest_updates_slider.slick({
                appendDots: $(".latest-updates-footer"),
                arrows: false,
                autoplay: false,
                dots: true,
                draggable: true,
                infinite: true,
                // lazyLoad: 'progressive',
                // mobileFirst: true,
                // nextArrow: $('.latest-updates-slick-next'),
                // prevArrow: $('.latest-updates-slick-prev'),
                responsive: [
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    }
                ],
                slidesToShow: 4,
                slidesToScroll: 1,
                speed: 700,
                touchThreshold: 10
            });
            $("body").on("click", ".home-latest-latest-updates-block .slick-dot", function() {
                home_latest_updates_slider.addClass("sliding");
                home_latest_updates_slider.on("afterChange", function() {
                    $(this).removeClass("sliding");
                });
            });
            home_latest_updates_slider.on("mousedown", function() {
                $(this).addClass("sliding");
            });
            home_latest_updates_slider.on("afterChange mouseup", function() {
                $(this).removeClass("sliding");
            });
        }
        // Initialize dynamic block preview (editor).
        if (window.acf) window.acf.addAction("render_block_preview/type=home-latest-updates", homeLatestUpdatesSlick);
    // 			function initializeCardBlock()
    // {
    // 	$('.call-out-card-block').attr('style', 'background-color: red');
    // }
    //
    // initializeCardBlock();
    //
    // // Initialize dynamic block preview (editor).
    // if (window.acf) {
    // 	window.acf.addAction('render_block_preview/type=call-out-card', initializeCardBlock);
    // }
    });
})(window.jQuery);


//# sourceMappingURL=block-home-latest-updates.js.map
